import React, { FC, useCallback, useEffect, useRef, useState } from 'react'
import UploadLogo from '../../assets/img/upload-logo.svg'
import ImageUploading from 'react-images-uploading'
import ReactCrop from 'react-image-crop'
import 'react-image-crop/dist/ReactCrop.css'

import './UploadImage.scss'
import CustomPopup from '../UI/Popup'
import CustomButton from '../UI/Buttons/CustomButton'

// TODO simplify and rename
interface UploadImageStep1Props {
  setImage: (props: any) => void
  uploadedImage?: string
  imageBorder: 'rounded-square' | 'circle'
}

const UploadImage: FC<UploadImageStep1Props> = ({ setImage, uploadedImage, imageBorder }) => {
  const onChange = (imageList: any, addUpdateIndex: any) => {
    setImages(imageList)
    setShowCroppier(true)
  }

  const [images, setImages] = useState<any>([])
  const imgRef = useRef(null)
  const previewCanvasRef = useRef(null)
  const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 1 })
  const [completedCrop, setCompletedCrop] = useState(null)
  const [showCroppier, setShowCroppier] = useState<boolean>(false)

  const onLoad = useCallback((img) => {
    imgRef.current = img
  }, [])

  const closeCropper = () => {
    // downloadImage(previewCanvasRef.current, crop)
    createImage()
    setShowCroppier(false)
  }

  const createImage = () => {
    if (!completedCrop || !previewCanvasRef.current) {
      return
    }
    const canvas: any = previewCanvasRef.current
    canvas.toBlob((blob: any) => setImage(blob), 'image/png', 1)
  }

  // download to test
  // const downloadImage = (canvas: any, crop: any) => {
  //   canvas.toBlob(
  //     (blob: any) => {
  //       const previewUrl = window.URL.createObjectURL(blob)

  //       const anchor = document.createElement('a')
  //       anchor.download = 'cropPreview.png'
  //       anchor.href = URL.createObjectURL(blob)
  //       anchor.click()

  //       window.URL.revokeObjectURL(previewUrl)
  //     },
  //     'image/png',
  //     1
  //   )
  // }

  useEffect(() => {
    if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
      return
    }

    const image: any = imgRef.current
    const canvas: any = previewCanvasRef.current
    const crop: any = completedCrop

    const scaleX = image.naturalWidth / image.width
    const scaleY = image.naturalHeight / image.height
    const ctx = canvas.getContext('2d')
    const pixelRatio = window.devicePixelRatio

    canvas.width = crop.width * pixelRatio
    canvas.height = crop.height * pixelRatio

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0)
    ctx.imageSmoothingQuality = 'high'

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    )
  }, [completedCrop])

  return (
    <div className='upload-crop-image'>
      <ImageUploading
        acceptType={['jpeg', 'png', 'jpg']}
        value={images}
        onChange={onChange}
        dataURLKey='data_url'
      >
        {({ imageList, onImageUpload, isDragging, dragProps, errors }) => (
          <div className={`upload-crop-image__wrapper image-border-${imageBorder}`}>
            {imageList.length === 0 && (
              <img
                onClick={onImageUpload}
                {...dragProps}
                alt='DEBUG'
                src={uploadedImage || UploadLogo}
              />
            )}
            {imageList.map((image, index) => (
              <>
                <div key={index} className='upload-crop-image__preview' onClick={onImageUpload}>
                  <canvas
                    ref={previewCanvasRef}
                    style={{
                      width: 130,
                      height: 130
                    }}
                  />
                </div>
                <CustomPopup
                  open={showCroppier}
                  offsetX={170}
                  closeOnDocumentClick={false}
                  className='upload-crop-image__cropper'
                >
                  {
                    <>
                      <div className='upload-crop-image__cropper-content__title'>
                        Please crop your image
                      </div>
                      <ReactCrop
                        src={images[0].data_url}
                        onImageLoaded={onLoad}
                        crop={crop as any}
                        onChange={(c: any) => setCrop(c)}
                        onComplete={(c: any) => setCompletedCrop(c)}
                      />
                      <CustomButton button='primary' size='big' onClick={closeCropper}>
                        Confirm
                      </CustomButton>
                    </>
                  }
                </CustomPopup>
              </>
            ))}
            {errors && (
              <div className='upload-post-images__wrapper__error'>
                {errors.acceptType && (
                  <div className='upload-post-images__wrapper__error__item'>
                    Allowed file types is 'jpeg', 'png'.
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </ImageUploading>
    </div>
  )
}

export default UploadImage
